export const config = {
  registrationEnabled: process.env.REACT_APP_REGISTRATION_ENABLED !== 'false'
};
